import React, {useState, useEffect, useContext} from 'react'
import { isMobile } from 'react-device-detect';
import {Route, Redirect} from 'react-router-dom';
import { globales } from '../helpers/Confi';
import UserContext from '../context/Globales/UserContext';

export const PublicRoutes = ({
    Autenticado,
    component: Component,
    ...rest
}) => {
    
    const [rutaLogin, setRutaLogin] = useState()
    const { DataPerfil } = useContext(UserContext)

    const parametros = globales();
 
    useEffect(() => {

        if (DataPerfil !== 160){
            
            !isMobile ? setRutaLogin("/Informe") : setRutaLogin("/MenuMobile")             
    
        }else {

            setRutaLogin("/informeonp");

        }
    }, [parametros.rutaServidor, DataPerfil]);
  
  return (
      <>
          <Route {...rest}
              component={(props) => (
                  (!Autenticado)
                      ? (<Component {...props} />)
                      : (<Redirect to={rutaLogin} />)
              )}
          />
      </>
    )
}
